let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a5Tjc")).then(() => parcelRequire('9zMo7'));